import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { StatisticGraph } from "../../../../../shared/components/statistic/StatisticGraph"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchUsersSummary } from "../companyReportsHomeApi"

export function UsersStat({ periodInDays }: { periodInDays: number }) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchUsersSummary, {
        queryName: CompanyReportsHomeQuery.USERS_SUMMARY,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
        forceMock: true,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.numberOfUsers.map((entry) => entry.date)}
            datasets={data.numberOfUsers.map((entry) => entry.number)}
            title={data?.reportSummary?.changeInPercentage}
        />
    )
}
